import React from 'react';
import { motion } from 'framer-motion';
import lifeVideoImage from '../assets/careers/life-video-image.jpg';
import playButtonIcon from '../assets/careers/play-button-icon.svg';

const CareersLifeSection: React.FC = () => {
  const handlePlayClick = () => {
    // Placeholder for video modal - can be implemented later
    console.log('Play video clicked');
  };

  return (
    <section className="relative bg-white py-16 lg:py-20">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="font-open-sans font-bold text-[52px] leading-[74px] text-[#323743] text-center mb-16"
          style={{ fontVariationSettings: "'wdth' 100" }}
        >
          Life at our company
        </motion.h2>

        {/* Video/Image Container */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative max-w-[960px] mx-auto rounded-[20px] overflow-hidden"
          style={{ height: '540px' }}
        >
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src={lifeVideoImage}
              alt="Life at our company"
              className="absolute w-full h-full object-cover"
              style={{ height: '118.7%', top: '-2.78%', width: '100.1%' }}
            />
          </div>

          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-[rgba(23,26,31,0.2)]"></div>

          {/* Play Button */}
          <button
            onClick={handlePlayClick}
            className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[92px] h-[82px] rounded-full bg-transparent border-0 flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
          >
            <div className="w-[64px] h-[64px] flex items-center justify-center">
              <img
                src={playButtonIcon}
                alt="Play video"
                className="w-full h-full"
              />
            </div>
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default CareersLifeSection;
